import React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import "./styles/UnsavedChangesModal.scss";

/**
 * Unsaved Changes Confirmation Modal
 * Displays when user tries to close form with unsaved changes
 */
const UnsavedChangesModal = ({ isOpen, onSave, onExit, onClose, isSaving = false }) => {
  if (!isOpen) return null;

  return (
    <Dialog
      onClose={onClose}
      title="Unsaved Changes"
      width={500}
      className="unsaved-changes-modal">
        <p className="mb-0">You have unsaved changes. Would you like to save them before exiting?</p>
      <DialogActionsBar>
        <div className="d-flex justify-content-end gap-2 w-100">
          <button
            className="btn btn-primary"
            onClick={onSave}
            disabled={isSaving}>
            {isSaving ? "Saving..." : "Save"}
          </button>
          <button
            className="btn btn-danger"
            onClick={onExit}
            disabled={isSaving}>
            Exit
          </button>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
};

export default UnsavedChangesModal;
